/* projects/speaker-platform/src/app/atoms/menu-item/menu-item.component.scss */
.menuitem a,
.menuitem button {
  display: flex;
  align-items: center;
  margin: 26px 0;
}
.menuitem a,
.menuitem a:hover,
.menuitem a:focus,
.menuitem a:visited {
  color: #505050;
  text-decoration: none;
}
.menuitem button {
  background: none;
  border: none;
}
.menuitem--logout button {
  justify-content: center;
  margin: 35px 0 0;
  width: 100%;
}
.menuitem__icon {
  font-size: 2Opx;
  margin-right: 22px;
  width: 22px;
}
/*# sourceMappingURL=menu-item.component-DYCXUEVC.css.map */
